import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["content"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Popover } from '@infl-ts/ui-advocate-components';
import KAD from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, ListItemText, MenuItem, MenuList, styled } from '@mui/material';
import { Translation } from 'react-i18next';
import NavLink from './nav-link';
import { jsx as _jsx } from "react/jsx-runtime";
var GroupButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover {\n    background-color: transparent;\n  }\n"])));

var NavGroup = function NavGroup(_ref) {
  var _content = _ref.content,
      boxProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "NavGroup",
    "data-source-file": "nav-group.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Popover, {
          noPadding: true,
          zIndex: function zIndex(t) {
            return t.zIndex.aboveStickyBlock;
          },
          content: function content() {
            return /*#__PURE__*/_jsx(MenuList, {
              children: _content.links.map(function (link) {
                return link.typename === 'NavBlockLink' || link.typename === 'NavBlockLogoLink' ? /*#__PURE__*/_jsx(MenuItem, {
                  children: /*#__PURE__*/_jsx(ListItemText, {
                    primary: t(link.display),
                    primaryTypographyProps: {
                      component: NavLink,
                      link: link
                    }
                  })
                }, link.id) : /*#__PURE__*/_jsx(MenuItem, {
                  children: /*#__PURE__*/_jsx(ListItemText, {
                    primary: /*#__PURE__*/_jsx(NavGroup, {
                      content: link
                    })
                  })
                }, link.id);
              })
            });
          },
          children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, boxProps), {}, {
            children: /*#__PURE__*/_jsx(GroupButton, {
              endIcon: /*#__PURE__*/_jsx(KAD, {}),
              color: "inherit",
              sx: {
                fontSize: function fontSize(theme) {
                  return theme.typography.body1.fontSize;
                },
                fontWeight: function fontWeight(theme) {
                  return theme.typography.fontWeightMedium;
                }
              },
              children: _content.typename === 'NavBlockLogoGroup' ? /*#__PURE__*/_jsx("img", {
                src: _content.imgUrl,
                style: {
                  width: '50px',
                  height: '100%',
                  objectFit: 'contain'
                },
                alt: _content.display
              }) : t(_content.display)
            })
          }))
        })
      });
    }
  });
};

export default NavGroup;